export default __webpack_public_path__ + "3b91e84ff968aaaa0bf786a0218f2116.svg";